import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
import { Card, CardContent, CardFooter, CardHeader } from './ui/Card';
import { Badge } from './ui/Badge';
interface PricingCardProps {
  name: string;
  price: string;
  description: string;
  features: string[];
  cta: string;
  ctaLink?: string;
  highlighted?: boolean;
  period?: string;
  savings?: string;
}
export function PricingCard({
  name,
  price,
  description,
  features,
  cta,
  ctaLink,
  highlighted = false,
  period = '/month',
  savings
}: PricingCardProps) {
  return <Card className={`flex flex-col h-full ${highlighted ? 'border-primary shadow-xl scale-105 z-10' : 'border-gray-200'}`} data-id="element-170">
      <CardHeader data-id="element-171">
        <div className="flex justify-between items-center mb-2" data-id="element-172">
          <h3 className={`text-xl font-bold ${highlighted ? 'text-primary' : 'text-gray-900'}`} data-id="element-173">
            {name}
          </h3>
          {highlighted && <Badge variant="default" data-id="element-174">Most Popular</Badge>}
        </div>
        <div className="flex items-baseline mb-2 flex-wrap gap-2" data-id="element-175">
          <span className="text-4xl font-bold text-gray-900" data-id="element-176">{price}</span>
          {price !== 'Custom' && <span className="text-gray-500 ml-1" data-id="element-177">{period}</span>}
          {savings && <Badge variant="secondary" className="ml-2 bg-green-100 text-green-800 hover:bg-green-200" data-id="element-178">
              {savings}
            </Badge>}
        </div>
        <p className="text-gray-500 text-sm" data-id="element-179">{description}</p>
      </CardHeader>
      <CardContent className="flex-grow" data-id="element-180">
        <ul className="space-y-4" data-id="element-181">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-182">
              <Check className="h-5 w-5 text-success mr-3 flex-shrink-0" data-id="element-183" />
              <span className="text-gray-600 text-sm" data-id="element-184">{feature}</span>
            </li>)}
        </ul>
      </CardContent>
      <CardFooter data-id="element-185">
        {ctaLink ? <a href={ctaLink} className="w-full" data-id="element-186">
            <Button variant={highlighted ? 'primary' : 'outline'} className="w-full" size="lg" data-id="element-187">
              {cta}
            </Button>
          </a> : <Button variant={highlighted ? 'primary' : 'outline'} className="w-full" size="lg" data-id="element-188">
            {cta}
          </Button>}
      </CardFooter>
    </Card>;
}